import React from "react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { Overline } from "@/components/blocks";
import { CLINIC, EMERGENCY_NOTICE, mailto } from "@/data/site";

const SECTIONS = [
  { h: "Information We Collect", p: "When you use our enquiry or appointment request forms, we collect the details you choose to provide — such as your name, phone number, email address, age, preferred date and time, and the reason for your consultation. We only collect information that is necessary to respond to your request." },
  { h: "How We Use Your Information", p: "Your information is used solely to respond to your enquiry, arrange or confirm appointments, and provide you with relevant clinical care and communication. We do not sell your personal information." },
  { h: "How We Protect Your Information", p: "Submissions are stored securely and are only accessible to authorised clinic staff through a protected, password-secured admin system. Patient information is never displayed publicly and is not exposed through public interfaces." },
  { h: "Sensitive Health Information", p: "We understand that health information is deeply personal. We handle all information with confidentiality and care, and access is restricted strictly to authorised clinic personnel." },
  { h: "Data Retention", p: "We retain enquiry and appointment records only for as long as necessary to provide care and to meet legitimate administrative and legal requirements." },
  { h: "Your Choices", p: "You may request that we update or delete your personal information held by the clinic. To make such a request, please contact us using the details below." },
];

export default function Privacy() {
  return (
    <div>
      <SEO title="Privacy Policy | Dr. Mithee's Clinic for Women, Noida" path="/privacy" description="Privacy policy for Dr. Mithee's Clinic for Women — how we collect, use and protect your information." />

      <section className="bg-gradient-to-b from-blush to-background pt-28 md:pt-36">
        <div className="container-clinic pb-12">
          <Reveal>
            <Overline>Privacy</Overline>
            <h1 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-charcoal sm:text-5xl">Privacy Policy</h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-taupe">
              Your privacy matters to us. This policy explains how {CLINIC.clinicName} handles the information you share with us.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="container-clinic pb-20 md:pb-28">
        <div className="mx-auto max-w-3xl space-y-10">
          {SECTIONS.map((s) => (
            <Reveal key={s.h}>
              <h2 className="font-serif text-2xl text-charcoal">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-taupe">{s.p}</p>
            </Reveal>
          ))}
          <Reveal>
            <div className="rounded-2xl bg-blush p-6">
              <h2 className="font-serif text-xl text-charcoal">Medical Emergencies</h2>
              <p className="mt-2 text-sm leading-relaxed text-taupe">{EMERGENCY_NOTICE}</p>
            </div>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-charcoal">Contact Us</h2>
            <p className="mt-3 text-base leading-relaxed text-taupe">
              For any privacy-related questions, please email us at{" "}
              <a href={mailto(CLINIC.email)} className="font-medium text-terracotta">{CLINIC.email}</a> or visit us at {CLINIC.address}.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
